'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ModalCloseButton } from '@/components/ui/modal-close-button/modal-close-button.component';
import { SheetClose } from '@/components/ui/sheet';

interface CartDrawerHeaderProps {
  itemCount: number;
}

export function CartDrawerHeader({ itemCount }: CartDrawerHeaderProps) {
  return (
    <header className="flex items-center justify-between gap-2 px-6 pt-5 pb-4">
      <div className="flex items-center gap-2">
        <h2
          className="text-2xl leading-8 font-bold text-gray-900"
          data-testid={DataTestIdEnum.CART_DRAWER_TITLE}
        >
          Carrinho
        </h2>

        {itemCount > 0 && (
          <span
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-success-100 text-sm font-bold text-green-500"
            data-testid={DataTestIdEnum.CART_DRAWER_COUNT_BADGE}
          >
            {itemCount}
          </span>
        )}
      </div>

      <SheetClose
        asChild
        className="shrink-0"
        data-testid={DataTestIdEnum.CART_DRAWER_CLOSE_BUTTON}
      >
        <ModalCloseButton label="Fechar carrinho" />
      </SheetClose>
    </header>
  );
}
